import { useEffect, useRef } from 'react';

export function useEffectWithPrev<T extends unknown[]>(
  effect: (prevDeps: [...T]) => void | (() => void),
  deps: [...T]
) {
  const prevDepsRef = useRef<T>();
  useEffect(() => {
    const destructor = effect(prevDepsRef.current ?? deps);
    prevDepsRef.current = deps;
    return destructor;
  }, deps);
}

export function useLayoutEffectWithPrev<T extends unknown[]>(
  effect: (prevDeps: [...T]) => void | (() => void),
  deps: [...T]
) {
  const prevDepsRef = useRef<T>();
  useEffect(() => {
    const destructor = effect(prevDepsRef.current ?? deps);
    prevDepsRef.current = deps;
    return destructor;
  }, deps);
}
